<template>
  <div class="drugControlModel">
    <div class="my-map-box">
      <MyMap ref="mapRef" />
    </div>

    <div class="selectarea">
      <el-form
        :inline="true"
        ref="formRef"
        :model="tableParams"
        class="form-inline"
      >
        <el-form-item label="" prop="">
          <h-date-timerange
            v-model:end="tableParams.endDate"
            v-model:start="tableParams.startDate"
          >
          </h-date-timerange>
        </el-form-item>
        <el-form-item label="" prop="">
          <el-button @click="setupclick" class="btn">设置</el-button>
          <el-button @click="searchbtn" class="btn">分析</el-button>
        </el-form-item>
      </el-form>
      <!-- <div class="btns">
          <el-form-item label="" prop="">
          <div class="btn">设置</div>
          <div class="btn">分析</div>
          </el-form-item>
        </div> -->
    </div>

    <div class="drug-content">
      <drugControlModelLeft></drugControlModelLeft>
      <drugControlModelRight
        :timeData="tableParams"
        @changeDefaultOpen="handleLabelLegend"
      ></drugControlModelRight>
    </div>
    <switchLabel
      class="drug-switch-label"
      v-model:open="labelLegendState"
      @getSwitchState="switchState"
    ></switchLabel>
    <el-dialog v-model="clickVisible" title="规则设置" width="40%">
      <setUpDialog
        v-model:maybelevelrole="tableParams.startDayNum"
        v-model:oftenoutrole="tableParams.threshold"
        @closeDialog="clickVisible = false"
      ></setUpDialog>
    </el-dialog>
  </div>
</template>
<script >
import {
  defineComponent,
  onMounted,
  ref,
  reactive,
  nextTick,
  watchEffect,
  toRefs,
  watch,
  provide,
  toRaw,
} from "vue";
import MyMap from "@/components/map/MyMap.vue";
import drugControlModelLeft from "./components/drugControlModelLeft";
import drugControlModelRight from "./components/drugControlModelRight";
import switchLabel from "./components/switchLabel";
import setUpDialog from "./components/setUpDialog.vue";
import { getDict } from "@/api/constant";
import { oftenOutFromDeviceId } from "@/api/publicSecurityResearch/drugControlModel.js";
import handleCoordinates from "@/components/map/js/modular/handleCoordinates";
import moment from "moment";
import _ from "lodash";
export default defineComponent({
  name: "",
  components: {
    drugControlModelLeft,
    drugControlModelRight,
    setUpDialog,
    MyMap,
    switchLabel,
  },
  props: {},
  setup(props) {
    const state = reactive({
      tableParams: {
        endDate: moment(new Date()).format("YYYY-MM-DD"),
        startDate: moment(new Date().getTime() - 1000 * 3600 * 24 * 90).format(
          "YYYY-MM-DD"
        ),
        libareId: 1,
        startDayNum: 0,
        threshold: 0,
      },
      value: "",
      clickVisible: false,
      labelLegendState: false,
      videoPlayList: [],
    });
    const refData = toRefs(state);
    const mapRef = ref(null);
    const { setVideoPoint, reverseVideoPoint } = handleCoordinates();
    //给子组件传值
    const ruleInfo = reactive({
      endDate: state.tableParams.endDate,
      startDate: state.tableParams.startDate,
      threshold: state.tableParams.threshold,
      startDayNum: state.tableParams.startDayNum, //疑似离开参数
    });
    provide("ruleInfo", ruleInfo);
    watchEffect(() => {
      if (ruleInfo.endDate || ruleInfo.startDate) {
        nextTick(() => {
          clearRegion();
          clearHeatMap();
          getoftenOutFromDeviceId();
        });
      }
    });
    const handleLabelLegend = (val) => {
      state.labelLegendState = val;
    };
    const switchState = (val) => {
      if (val.name == "分布图") {
        val.status ? createRegion(state.videoPlayList) : clearRegion();
      } else {
        val.status ? createHeatMap(state.videoPlayList) : clearHeatMap();
      }
    };
    // 获取数据字典 调用子组件接口,频繁出没,疑似离开
    const queryMenuType = async () => {
      const res = await getDict("often_out_rule");
      const age = await getDict("maybe_level_rule");
      if (res.dict.length > 0) {
        state.tableParams.threshold = res.dict[0].value;
      }
      if (age.dict.length > 0) {
        state.tableParams.startDayNum = age.dict[0].value;
      }
    };
    // 点位数据
    const getoftenOutFromDeviceId = async () => {
      const parms = {
        libareId: 1,
        endDate: ruleInfo.endDate,
        startDate: ruleInfo.startDate,
        limit: 500,
        // threshold: ruleInfo.threshold,
        // startDayNum: ruleInfo.startDayNum,
      };
      const res = await oftenOutFromDeviceId(parms);
      if (res.code == 0) {
        state.videoPlayList = res.page.list.map((item) => {
          if (item.longitude && item.latitude) {
            let coordinates = setVideoPoint([
              Number(item.longitude),
              Number(item.latitude),
            ]);
            // let coordinates = [Number(item.longitude), Number(item.latitude)];
            item.coordinates = coordinates;
            item.weight = Number(item.countNum);
            return item;
          }
        });
        nextTick(() => {
          createHeatMap(state.videoPlayList);
          // createRegion(state.videoPlayList);
        });
      }
    };

    //创建热力图
    const createHeatMap = (list) => {
      mapRef.value && mapRef.value.clickaddHeatmap(list);
    };
    //清除热力图
    const clearHeatMap = () => {
      mapRef.value && mapRef.value.clearHeatmap();
    };
    //创建区域图
    const createRegion = (list) => {
      let newList = list.map((item) => {
        let pointInfo = {
          name: item.deviceName,
          id: item.deviceId,
          type: 1,
          // poiType: ,
          showType: 2,
          location: toRaw(item.coordinates),
          click: (e) => {},
        };
        return pointInfo;
      });
      console.log(newList);
      mapRef.value && mapRef.value.loadMarker(newList);
    };
    //清除区域图
    const clearRegion = (list) => {
      mapRef.value && mapRef.value.clearPoint();
    };
    const searchbtn = () => {
      for (let key in ruleInfo) {
        ruleInfo[key] = state.tableParams[key];
      }
    };
    const setupclick = () => {
      state.clickVisible = true;
    };
    queryMenuType();

    onMounted(() => {});
    return {
      ...refData,
      mapRef,
      searchbtn,
      setupclick,
      handleLabelLegend,
      switchState,
    };
  },
});
</script>
<style  lang='scss' scoped >
.drugControlModel {
  height: 100%;
  width: 100%;
  position: relative;
  .my-map-box {
    position: relative;
    height: 100%;
    width: 100%;
    z-index: 1;
  }

  .selectarea {
    border-radius: 8px;
    background-color: rgba(0, 0, 0, 0.2);
    background-repeat: no-repeat;

    position: absolute;
    top: 50px;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 2;
    padding: 10px;
    box-sizing: border-box;
    ::v-deep .el-select {
      margin-right: 15px !important;
    }
    .selectareaitme {
      z-index: 5;
    }
    ::v-deep .el-input__inner {
      background-color: #065080 !important;
      outline: none !important;
      border: none !important;

      input {
        background-color: #065080 !important;
      }
    }
  }
  // .form-inline {
  :deep(.el-input__inner) {
    background-color: transparent !important;
    color: #fff;
    font-size: 16px;
  }
  // }

  .drug-content {
    height: 100%;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 3;
    pointer-events: none;
    display: flex;

    .drug-left {
      pointer-events: auto;
    }
  }
  :deep(.el-date-editor .el-range-input) {
    // background-color: transparent;
    color: #fff;
    font-size: 16px;
  }
  :deep(.el-input-group__append) {
    background-color: transparent;
    color: #fff;
    font-size: 16px;
  }

  :deep(.el-form-item) {
    margin-bottom: 0;
  }
}
</style>